import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ClcdComponent } from './clcd.component';
import { AwardsComponent } from './awards/awards.component';
import { StudyProgramsComponent } from './study-programs/study-programs.component';
import { BooksLikeThisComponent } from './books-like-this/books-like-this.component';
import { ReviewsComponent } from './reviews/reviews.component';
import { ComponentsModule } from '../../../../components/components.module';
import { SharedModule } from '../../../../shared/shared.module';
import { ReviewComponent } from './reviews/review/review.component';

@NgModule({
  declarations: [
    ClcdComponent,
    AwardsComponent,
    StudyProgramsComponent,
    BooksLikeThisComponent,
    ReviewsComponent,
    ReviewComponent,
  ],

  imports: [CommonModule, SharedModule, ComponentsModule],
  exports: [ClcdComponent, AwardsComponent, StudyProgramsComponent, BooksLikeThisComponent],
})
export class ClcdModule {}
